import { render, staticRenderFns } from "./SellerAddress.vue?vue&type=template&id=01c5f200&"
import script from "./SellerAddress.vue?vue&type=script&lang=js&"
export * from "./SellerAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports